.o{justify-content:center;}